import { render } from "./AppMetadataLink.vue?vue&type=template&id=cac6cd98"
import script from "./AppMetadataLink.vue?vue&type=script&lang=js"
export * from "./AppMetadataLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__